import { render, staticRenderFns } from "./CompleteUserRegister.vue?vue&type=template&id=5677a4fb&scoped=true&"
import script from "./CompleteUserRegister.vue?vue&type=script&lang=js&"
export * from "./CompleteUserRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompleteUserRegister.vue?vue&type=style&index=0&id=5677a4fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677a4fb",
  null
  
)

export default component.exports